import { parseAndSplitByH2, type ChunkAST } from '@/lib/parseMarkdown'

const formatBranchHeadingTitle = (title: string) => title.replace(/\b[a-z]/g, (char) => char.toUpperCase())
const normalizedMarkdownChunksCache = new Map<string, ChunkAST[]>()

const normalizeBranchNodeMarkdown = (markdown: string, title: string) => {
  return markdown.replace(
    /^(#{1,6})[^\n]*\{#[^\n]+\}/,
    `$1 ${formatBranchHeadingTitle(title)}`
  )
}

export const getPlaybookBranchNodeChunks = (
  nodeId: string, markdown: string, title: string,
  footnotesMarkdown?: string
) => {
  const fullMarkdown = footnotesMarkdown
    ? `${markdown}\n\n${footnotesMarkdown}`
    : markdown
  const cacheKey = `${nodeId}::${title}::${fullMarkdown}`
  const cachedChunks = normalizedMarkdownChunksCache.get(cacheKey)
  if (cachedChunks) return cachedChunks
  const chunks = parseAndSplitByH2(
    normalizeBranchNodeMarkdown(fullMarkdown, title)
  )
  normalizedMarkdownChunksCache.set(cacheKey, chunks)
  return chunks
}
